import { useCallMeBanner } from '#features/CallMeBanner';
import { useCommunicationBanner } from '#features/Communication';
import { useCompanyNameModerationBanner } from '#features/CompanyNameModerationBanner';
import { useStoreIsBannedBannerOpen } from '#features/StoreIsBannedBanner';
import { useIsOnboardingCompleted } from '#shared/api/onboarding';
import { checkIsLiteStore } from '#shared/lib/storeInfo';
import { checkIsYCP } from '#shared/lib/ycp';
import { resolveTopBarState } from './resolveTopBarState';

export const useTopBarState = () => {
    const isOnboardingCompleted = useIsOnboardingCompleted();
    const { isOpen: isCallMeBannerOpen } = useCallMeBanner();
    const { isOpen: isCompanyNameModerationBannerOpen, isLoading: isCompanyNameModerationLoading } =
        useCompanyNameModerationBanner();
    const isStoreBannedBannerOpen = useStoreIsBannedBannerOpen();
    const { communication, close: closeCommunication, action: actionCommunication } = useCommunicationBanner();

    const state = resolveTopBarState({
        isCallMeBannerOpen,
        isConfiguredBannerOpen: Boolean(communication),
        isCompanyNameModerationBannerOpen,
        isCompanyNameModerationLoading,
        isLiteStore: checkIsLiteStore(),
        isOnboardingCompleted,
        isStoreBannedBannerOpen,
        isYCP: checkIsYCP(),
    });

    return { ...state, communication, closeCommunication, actionCommunication };
};
